import type { UnknownAction } from "@reduxjs/toolkit";

import {
  FETCHING_CUSTOM_FIELDS_REQUEST,
  FETCHING_CUSTOM_FIELDS_SUCCEEDED,
  FETCHING_CUSTOM_FIELDS_FAILED,
} from "../actions/actionTypes";

import { CustomField, FetchCustomFieldsResponse } from "../../types/customFields";
import { DELETING_CUSTOM_FIELD_SUCCEEDED, UPDATING_CUSTOM_FIELD_SUCCEEDED } from "src/legacy/redux/actions/actionTypes";

interface CustomFields {
  loading: boolean;
  items: CustomField[];
  errors: any | null;
  succeeded: boolean;
}

const initialState: CustomFields = {
  loading: false,
  items: [],
  errors: null,
  succeeded: false
};

type Action = UnknownAction;

export function customFieldsReducer(
  state: CustomFields = initialState,
  action: Action,
): CustomFields {
  switch (action.type) {
    case FETCHING_CUSTOM_FIELDS_REQUEST: {
      return {
        ...state,
        loading: true,
        errors: null,
        succeeded: false
      };
    }

    case FETCHING_CUSTOM_FIELDS_SUCCEEDED: {
      const data = action.payload as CustomField[];
      return {
        ...state,
        loading: false,
        items: data,
        errors: null,
        succeeded: true
      };
    }

    case FETCHING_CUSTOM_FIELDS_FAILED: {
      return {
        ...state,
        loading: false,
        errors: action.payload,
        succeeded: false
      };
    }

    case DELETING_CUSTOM_FIELD_SUCCEEDED: {
      const response = action.payload as any;
      const id = response.id;

      return {
        ...state,
        items: state.items.filter((field) => field.id !== id),
      };
    }

    case UPDATING_CUSTOM_FIELD_SUCCEEDED: {
      
      const response = action.payload as any;
      const id = response.id;

        let items = state.items.map(item => {
          if (item.id != id) {
            return item;
          }
    
          return {
            ...item, 
            ...response.response
            };
          }); 
              
          return {
            ...state,
            items: items,
          };
          }
          

    default:
      return state;
  }
}